<template>
	<v-alert v-if="donation" :value="true" type="warning" class="alert ml-4 mr-4 mb-3">
		Uwaga! Suma kwoty dotacji z projektu ({{formatMoney(donation)}} PLN) została przekroczona.
	</v-alert>
</template>

<script>
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "ProjectInvoicesDonationWarning",

		mixins: [Numbers],

		props: {
			donation: null
		}
	};
</script>

<style scoped>
@media print {
	.alert {
		background-color: lightgrey !important;
		color: black;
		border: none;
	}
	.alert >>> .v-icon {
		display: none;
	}
}
</style>
